import styled from "styled-components";
import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-height: 100vh;
  align-self: center;
  background-image: url("/imageBackHealth.png");
  background-repeat: no-repeat;
  background-size: cover;
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const TopText = styled.div`
  margin-top: 40px;
  text-align: center;
  color: ${Variables.colorRed};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 10px;
  width: 60%;

  @media (max-width: 820px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const Title = styled.h1`
  font-weight: 400;
  font-weight: bold;
  text-align: center;
  color: #f9b233;
`;

export const TextHeader = styled.p`
  margin-top: 10px;
  text-align: center;
  color: #000000;
  font-size: 18px;
  font-weight: 400;
  font-family: "Fanwood Text", serif;
`;

export const ContainerBackAndInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  width: 70%;
`;

export const BackButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

export const TextBack = styled.h3`
  margin-left: 10px;
  font-weight: 600;
  color: ${Variables.colorBlackDark};
`;

export const ContainerInformation = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  @media (max-width: 820px) {
    flex-direction: column;
  }
`;

export const TextInformation = styled.p`
  margin-left: 10px;
  font-size: 20px;
  font-weight: 500;
`;

export const ContainerInfo = styled.div`
  margin: 5px auto;
  width: 70%;
  font-weight: 400;
  color: ${Variables.colorBlackDark};

  @media (max-width: 820px) {
    width: 100%;
    text-align: center;
  }
`;

export const ContainerTransparent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 10px 0;
  margin-bottom: 60px;
  padding: 20px 20px;
  width: 90%;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
`;

export const TextInfo = styled.div`
  font-size: 1.4em;
  font-weight: 500;
  font-family: "Fanwood Text", serif;
  color: ${Variables.colorBlackDark};

  @media (max-width: 820px) {
    margin: 30px 0;
  }
`;

export const TextInformative = styled.h3`
  margin: 15px 0;
  width: 100%;
  font-size: 1.5em;
  font-weight: 500;
  text-align: center;

  color: #c2820f;
`;

export const RedText = styled.span`
  color: #fe1010;
  display: inline;
`;

export const ContainText = styled.div`
  padding: 10px;
  width: 100%;
  border-radius: 20px;
  background-color: ${Variables.colorBlue};
`;

export const TextBar = styled.p`
  text-align: center;
  color: ${Variables.colorWhite};
`;
